import { render } from "./Home.vue?vue&type=template&id=b3fbcea8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b3fbcea8&lang=scss&scoped=true"

import exportComponent from "/Users/niels/Development/kentaa-time/vue/playground/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fbcea8"]])

export default __exports__